export default "__VITE_ASSET__dov4y4GgHUuOZZXEDigs4Q__"